<template>
  <div id='order-confirmation'>


    <!-- kuryr - objednava pro sebe -->
    <div v-if="(Order.data.delivery.code == 'CUSTOM') && (Order.data.delivery.billing.shippingIsSame == true)">
      <h2>Už kvetou!</h2>
      <p class='thankyou'>Děkujeme Ti za objednávku! Pomalu si&nbsp;chystej vázu s vodou, ať Ti tvoje kráska vydrží co nejdéle. :)</p>
    </div>

    <!-- kuryr - objednava pro nekoho -->
    <div v-if="(Order.data.delivery.code == 'CUSTOM') && (Order.data.delivery.billing.shippingIsSame == false)">
      <h2>Už kmitáme!</h2>
      <p class='thankyou'>Buď v pohodě, už jsme to jednou, možná dvakrát, dělaly. Tak nám věř, že to dáme!</p>
    </div>

    <!-- osobni odber -->
    <div v-if="Order.data.delivery.code.match(/^BRANCH/)">
      <h2>Těpic!</h2>
      <p class='thankyou'>Ty fakt chceš přijít k nám? Tak to jdem uklízet!</p>
    </div>

    <p class='ordernumber'>Tvá objednávka je <b class='nowrap'>{{Order.data.orderNumber}}</b> a&nbsp;potvrzení už bys měl/a mít v e-mailu.</p>

    <p class='merchant-note'>
      Děkujeme!<br><br>

      Jana a Markéta,<br>
      Tvé <a href="https://www.instagram.com/explore/tags/kvetinoveholky/" target="_blank">#kvetinoveholky</a>
    </p>

    <a href="javascript:" class="pfm-button shop-more" @click="backToShop">
      Naplníme další vázu? 😜
    </a>
  </div>
</template>

<script type = "text/javascript" >

import Order from '@/order'
import Router from '@/router'

export default {
  props: {
  },
  components: {
  },
  data () {
    return {
      Order: Order
    }
  },
  created() {
    console.log('Confirmation.vue: created()', Order.data, Object.keys(Order.data))
    console.log('scrolling to top')
    window.scrollTo(0,0)
    if (Object.keys(Order.data).length == 0) {
      console.log('redirecting to main cart')
      Router.push({name: 'Order'})
    }
  },
  methods: {
    backToShop() {
      parent.postMessage({action: 'reloadCart'}, '*')
      console.log('clicked shop more')
      Router.push({name: 'Order'})
    }
  }
};
</script>

<style scoped lang='less'>
#order-confirmation {
  p.thankyou {
    padding: 20px 0 20px 0;
  }

  p.merchant-note {
    padding: 50px 0 0 0;
  }

  .shop-more {
    margin-top: 50px;
  }
}
</style>
